import { useDispatch } from 'react-redux';
import * as actions from '../../actions';
import mapDispatchToActions from '../../../utils/mapDispatchToActions';
/**
 * Provides access to all subscription actions for use in a React component.
 *
 * Automatically ensures that dispatch is mapped to each action.
 *
 * ```js
 * import { subscription } from '@minerva-analytics/pantheon';
 *
 * const Test = () => {
 *   const actions = subscription.hooks.useSubscriptionActions();
 *
 *   // use your actions as needed
 *
 *   return <div>Test</div>;
 * }
 * ```
 *
 * @returns {object} - An object that holds all of the `subscription` actions
 */

var useSubscriptionActions = function useSubscriptionActions() {
  var dispatch = useDispatch();
  return mapDispatchToActions(dispatch, actions);
};

export default useSubscriptionActions;